// CID-OE — Classificação Internacional de Doenças em Odontologia e Estomatologia
// Capítulo K00-K14: Doenças da cavidade oral, das glândulas salivares e dos maxilares

const CID_ODONTOLOGICO = [
  { codigo: 'K00', descricao: 'Distúrbios do desenvolvimento e da erupção dos dentes' },
  { codigo: 'K00.0', descricao: 'Anodontia' },
  { codigo: 'K00.00', descricao: 'Anodontia parcial [hipodontia] [oligodontia]' },
  { codigo: 'K00.01', descricao: 'Anodontia total' },
  { codigo: 'K00.09', descricao: 'Anodontia inespecífica' },
  { codigo: 'K00.1', descricao: 'Dentes supranumerários' },
  { codigo: 'K00.10', descricao: 'Dentes supranumerários — região dos incisivos e dos caninos [Mesiodens]' },
  { codigo: 'K00.11', descricao: 'Dentes supranumerários — região dos pré-molares' },
  { codigo: 'K00.12', descricao: 'Dentes supranumerários — região dos molares [Distomolar/Paramolar]' },
  { codigo: 'K00.19', descricao: 'Dentes supranumerários, não especificados' },
  { codigo: 'K00.2', descricao: 'Anomalias do tamanho e da forma dos dentes' },
  { codigo: 'K00.20', descricao: 'Macrodontia' },
  { codigo: 'K00.21', descricao: 'Microdontia' },
  { codigo: 'K00.22', descricao: 'Concrescência' },
  { codigo: 'K00.23', descricao: 'Fusão e germinação' },
  { codigo: 'K00.24', descricao: 'Dente evaginado [tubérculo oclusal]' },
  { codigo: 'K00.25', descricao: 'Dente invaginado ["dens in dente"] [odontoma dilatado]' },
  { codigo: 'K00.26', descricao: 'Pré-molarização' },
  { codigo: 'K00.27', descricao: 'Tubérculos anormais e pérolas de esmalte [enameloma]' },
  { codigo: 'K00.28', descricao: 'Taurodontismo' },
  { codigo: 'K00.29', descricao: 'Anormalidades inespecíficas e outras do tamanho e da forma dos dentes' },
  { codigo: 'K00.3', descricao: 'Dentes manchados' },
  { codigo: 'K00.30', descricao: 'Manchas do esmalte endêmicas (fluoreto) [fluorose dental]' },
  { codigo: 'K00.31', descricao: 'Manchas do esmalte não-endêmicas [opacidade não associada ao fluoreto]' },
  { codigo: 'K00.39', descricao: 'Dentes manchados, não especificado' },
  { codigo: 'K00.4', descricao: 'Distúrbios na formação dos dentes' },
  { codigo: 'K00.40', descricao: 'Hipoplasia do esmalte' },
  { codigo: 'K00.41', descricao: 'Hipoplasia pré-natal do esmalte' },
  { codigo: 'K00.42', descricao: 'Hipoplasia neonatal do esmalte' },
  { codigo: 'K00.43', descricao: 'Aplasia e hipoplasia do cemento' },
  { codigo: 'K00.44', descricao: 'Dilaceração' },
  { codigo: 'K00.45', descricao: 'Odontodisplasia [odontodisplasia regional]' },
  { codigo: 'K00.46', descricao: 'Dente de Turner' },
  { codigo: 'K00.48', descricao: 'Outros distúrbios da formação dentária especificados' },
  { codigo: 'K00.49', descricao: 'Distúrbio na formação dentária, não especificados' },
  { codigo: 'K00.5', descricao: 'Anomalias hereditárias da estrutura dentária, não classificadas em outra parte' },
  { codigo: 'K00.50', descricao: 'Amelogênese imperfeita' },
  { codigo: 'K00.51', descricao: 'Dentinogênese imperfeita' },
  { codigo: 'K00.52', descricao: 'Odontogênese imperfeita' },
  { codigo: 'K00.58', descricao: 'Outros distúrbios hereditários da estrutura dentária [Dente em concha/Displasia de dentina]' },
  { codigo: 'K00.59', descricao: 'Anomalias hereditárias da estrutura dentária, inespecíficas' },
  { codigo: 'K00.6', descricao: 'Distúrbios da erupção dentária' },
  { codigo: 'K00.60', descricao: 'Dentes natais' },
  { codigo: 'K00.61', descricao: 'Dentes neonatais' },
  { codigo: 'K00.62', descricao: 'Erupção prematura dos dentes ["dentia praecox"]' },
  { codigo: 'K00.63', descricao: 'Dentes temporários [decíduos] retidos [persistentes]' },
  { codigo: 'K00.64', descricao: 'Erupção tardia' },
  { codigo: 'K00.65', descricao: 'Queda prematura de dentes temporários [decíduos]' },
  { codigo: 'K00.68', descricao: 'Outros distúrbios da erupção dentária especificados' },
  { codigo: 'K00.69', descricao: 'Distúrbio da erupção dentária, não especificado' },
  { codigo: 'K00.7', descricao: 'Síndrome da erupção dentária' },
  { codigo: 'K00.8', descricao: 'Outros distúrbios do desenvolvimento dos dentes' },
  { codigo: 'K00.80', descricao: 'Alteração de cor na formação dos dentes, devida a incompatibilidade sanguínea' },
  { codigo: 'K00.81', descricao: 'Alteração de cor na formação dos dentes, devida a malformação do sistema biliar' },
  { codigo: 'K00.82', descricao: 'Alteração de cor na formação dos dentes, devida a porfiria' },
  { codigo: 'K00.83', descricao: 'Alteração de cor na formação dos dentes, devida a tetraciclinas' },
  { codigo: 'K00.88', descricao: 'Outros distúrbios especificados de desenvolvimento dos dentes' },
  { codigo: 'K00.9', descricao: 'Distúrbio não especificado do desenvolvimento dentário' },

  { codigo: 'K01', descricao: 'Dentes inclusos e impactados' },
  { codigo: 'K01.0', descricao: 'Dentes inclusos' },
  { codigo: 'K01.1', descricao: 'Dentes impactados' },
  { codigo: 'K01.10', descricao: 'Dente impactado — incisivo superior' },
  { codigo: 'K01.11', descricao: 'Dente impactado — incisivo inferior' },
  { codigo: 'K01.12', descricao: 'Dente impactado — canino superior' },
  { codigo: 'K01.13', descricao: 'Dente impactado — canino inferior' },
  { codigo: 'K01.14', descricao: 'Dente impactado — pré-molar superior' },
  { codigo: 'K01.15', descricao: 'Dente impactado — pré-molar inferior' },
  { codigo: 'K01.16', descricao: 'Dente impactado — molar superior' },
  { codigo: 'K01.17', descricao: 'Dente impactado — molar inferior' },
  { codigo: 'K01.18', descricao: 'Dentes supranumerários impactados' },
  { codigo: 'K01.19', descricao: 'Dente impactado não especificado' },

  { codigo: 'K02', descricao: 'Cárie dentária' },
  { codigo: 'K02.0', descricao: 'Cáries limitadas ao esmalte [manchas brancas / cáries iniciais]' },
  { codigo: 'K02.1', descricao: 'Cáries da dentina' },
  { codigo: 'K02.2', descricao: 'Cárie do cemento' },
  { codigo: 'K02.3', descricao: 'Cáries dentárias estáveis' },
  { codigo: 'K02.4', descricao: 'Odontoclasia [melanodontia infantil / melanodontoclasia]' },
  { codigo: 'K02.8', descricao: 'Outras cáries dentárias' },
  { codigo: 'K02.9', descricao: 'Cárie dentária, sem outra especificação' },

  { codigo: 'K03', descricao: 'Outras doenças dos tecidos dentários duros' },
  { codigo: 'K03.0', descricao: 'Atrito dentário excessivo' },
  { codigo: 'K03.00', descricao: 'Atrito dentário — oclusal' },
  { codigo: 'K03.01', descricao: 'Atrito dentário — proximal' },
  { codigo: 'K03.08', descricao: 'Outros atritos dentários especificados' },
  { codigo: 'K03.09', descricao: 'Atrito dentário não especificado' },
  { codigo: 'K03.1', descricao: 'Abrasão dentária' },
  { codigo: 'K03.10', descricao: 'Abrasão dentária por dentifrício [defeito cuneiforme SOE]' },
  { codigo: 'K03.11', descricao: 'Abrasão dentária habitual' },
  { codigo: 'K03.12', descricao: 'Abrasão dentária ocupacional' },
  { codigo: 'K03.13', descricao: 'Abrasão dentária tradicional/ritual' },
  { codigo: 'K03.18', descricao: 'Outras abrasões dentárias especificadas' },
  { codigo: 'K03.19', descricao: 'Abrasão dentária, não especificada' },
  { codigo: 'K03.2', descricao: 'Erosão dentária' },
  { codigo: 'K03.20', descricao: 'Erosão dentária ocupacional' },
  { codigo: 'K03.21', descricao: 'Erosão dentária devida a regurgitação ou vômito persistentes' },
  { codigo: 'K03.22', descricao: 'Erosão dentária devida a dieta' },
  { codigo: 'K03.23', descricao: 'Erosão dentária devida a drogas e medicamentos' },
  { codigo: 'K03.24', descricao: 'Erosão dentária idiopática' },
  { codigo: 'K03.28', descricao: 'Outras erosões dentárias especificadas' },
  { codigo: 'K03.29', descricao: 'Erosão dentária, não especificada' },
  { codigo: 'K03.3', descricao: 'Reabsorção patológica dos dentes' },
  { codigo: 'K03.30', descricao: 'Reabsorção patológica dos dentes — externa' },
  { codigo: 'K03.31', descricao: 'Reabsorção patológica dos dentes — interna [granuloma interno da polpa]' },
  { codigo: 'K03.39', descricao: 'Reabsorção patológica dos dentes, não especificada' },
  { codigo: 'K03.4', descricao: 'Hipercementose' },
  { codigo: 'K03.5', descricao: 'Ancilose dentária' },
  { codigo: 'K03.6', descricao: 'Depósitos [acreções] nos dentes' },
  { codigo: 'K03.60', descricao: 'Película pigmentada (alaranjado/negro/verde)' },
  { codigo: 'K03.61', descricao: 'Depósito dentário devido ao tabaco' },
  { codigo: 'K03.62', descricao: 'Depósito dentário por betel' },
  { codigo: 'K03.63', descricao: 'Outros depósitos moles macroscópicos [matéria alba]' },
  { codigo: 'K03.64', descricao: 'Tártaro supragengival' },
  { codigo: 'K03.65', descricao: 'Tártaro subgengival' },
  { codigo: 'K03.66', descricao: 'Placa dentária' },
  { codigo: 'K03.68', descricao: 'Outros depósitos dentários especificados' },
  { codigo: 'K03.69', descricao: 'Depósitos dentários, não especificados' },
  { codigo: 'K03.7', descricao: 'Alterações pós-eruptivas da cor dos tecidos duros dos dentes' },
  { codigo: 'K03.70', descricao: 'Alteração de cor devida a metais e compostos metálicos' },
  { codigo: 'K03.71', descricao: 'Alteração de cor devida a sangramento da polpa' },
  { codigo: 'K03.72', descricao: 'Alteração de cor devida ao hábito de mascar (betel/tabaco)' },
  { codigo: 'K03.78', descricao: 'Outras alterações da cor especificadas' },
  { codigo: 'K03.79', descricao: 'Alteração da cor não especificada' },
  { codigo: 'K03.8', descricao: 'Outras doenças especificadas dos tecidos duros dos dentes' },
  { codigo: 'K03.80', descricao: 'Dentina sensível' },
  { codigo: 'K03.81', descricao: 'Alterações do esmalte irradiado' },
  { codigo: 'K03.88', descricao: 'Outras doenças específicas dos tecidos duros dos dentes' },
  { codigo: 'K03.9', descricao: 'Doenças dos tecidos duros dos dentes, não especificada' },

  { codigo: 'K04', descricao: 'Doenças da polpa e dos tecidos periapicais' },
  { codigo: 'K04.0', descricao: 'Pulpite' },
  { codigo: 'K04.00', descricao: 'Pulpite inicial (hiperemia)' },
  { codigo: 'K04.01', descricao: 'Pulpite aguda' },
  { codigo: 'K04.02', descricao: 'Pulpite supurativa [abscesso pulpar]' },
  { codigo: 'K04.03', descricao: 'Pulpite crônica' },
  { codigo: 'K04.04', descricao: 'Pulpite crônica ulcerativa' },
  { codigo: 'K04.05', descricao: 'Pulpite crônica hiperplásica [pólipo pulpar]' },
  { codigo: 'K04.08', descricao: 'Outras pulpites especificadas' },
  { codigo: 'K04.09', descricao: 'Pulpite não especificada' },
  { codigo: 'K04.1', descricao: 'Necrose da polpa [gangrena da polpa]' },
  { codigo: 'K04.2', descricao: 'Degeneração da polpa [calcificação/cálculos/dentículos]' },
  { codigo: 'K04.3', descricao: 'Formação anormal de tecidos duros na polpa' },
  { codigo: 'K04.3X', descricao: 'Dentina secundária ou irregular' },
  { codigo: 'K04.4', descricao: 'Periodontite apical aguda de origem pulpar' },
  { codigo: 'K04.5', descricao: 'Periodontite apical crônica [granuloma apical]' },
  { codigo: 'K04.6', descricao: 'Abscesso periapical com fístula' },
  { codigo: 'K04.60', descricao: 'Fístula no antro maxilar' },
  { codigo: 'K04.61', descricao: 'Fístula na cavidade nasal' },
  { codigo: 'K04.62', descricao: 'Fístula na cavidade oral' },
  { codigo: 'K04.63', descricao: 'Fístula na pele' },
  { codigo: 'K04.69', descricao: 'Abscesso periapical com fístula, não especificado' },
  { codigo: 'K04.7', descricao: 'Abscesso periapical sem fístula' },
  { codigo: 'K04.8', descricao: 'Cisto radicular [apical/periapical]' },
  { codigo: 'K04.80', descricao: 'Cisto radicular apical e lateral' },
  { codigo: 'K04.81', descricao: 'Cisto radicular residual' },
  { codigo: 'K04.82', descricao: 'Cisto paradental inflamatório' },
  { codigo: 'K04.89', descricao: 'Cisto radicular, não especificado' },
  { codigo: 'K04.9', descricao: 'Outras doenças da polpa e dos tecidos periapicais, não especificadas' },

  { codigo: 'K05', descricao: 'Gengivite e doenças periodontais' },
  { codigo: 'K05.0', descricao: 'Gengivite aguda' },
  { codigo: 'K05.00', descricao: 'Gengivoestomatite estreptocócica aguda' },
  { codigo: 'K05.08', descricao: 'Outra gengivite aguda especificada' },
  { codigo: 'K05.09', descricao: 'Gengivite aguda, não especificada' },
  { codigo: 'K05.1', descricao: 'Gengivite crônica' },
  { codigo: 'K05.10', descricao: 'Gengivite crônica marginal simples' },
  { codigo: 'K05.11', descricao: 'Gengivite crônica hiperplásica' },
  { codigo: 'K05.12', descricao: 'Gengivite crônica ulcerativa' },
  { codigo: 'K05.13', descricao: 'Gengivite crônica descamativa' },
  { codigo: 'K05.18', descricao: 'Outras gengivites crônicas especificadas' },
  { codigo: 'K05.19', descricao: 'Gengivite crônica, não especificada' },
  { codigo: 'K05.2', descricao: 'Periodontite aguda' },
  { codigo: 'K05.20', descricao: 'Abscesso periodontal de origem gengival sem fístula' },
  { codigo: 'K05.21', descricao: 'Abscesso periodontal de origem gengival com fístula' },
  { codigo: 'K05.22', descricao: 'Pericoronite aguda' },
  { codigo: 'K05.28', descricao: 'Outras periodontites agudas especificadas' },
  { codigo: 'K05.29', descricao: 'Periodontite aguda, não especificada' },
  { codigo: 'K05.3', descricao: 'Periodontite crônica' },
  { codigo: 'K05.30', descricao: 'Periodontite crônica simples' },
  { codigo: 'K05.31', descricao: 'Periodontite crônica complexa' },
  { codigo: 'K05.32', descricao: 'Pericoronarite crônica' },
  { codigo: 'K05.33', descricao: 'Folículo espessado' },
  { codigo: 'K05.38', descricao: 'Outras periodontites crônicas especificadas' },
  { codigo: 'K05.39', descricao: 'Periodontite crônica, não especificada' },
  { codigo: 'K05.4', descricao: 'Periodontose [periodontose juvenil]' },
  { codigo: 'K05.5', descricao: 'Outras doenças periodontais' },

  { codigo: 'K06', descricao: 'Outros transtornos da gengiva e do rebordo alveolar sem dentes' },
  { codigo: 'K06.0', descricao: 'Retração gengival' },
  { codigo: 'K06.00', descricao: 'Retração gengival localizada' },
  { codigo: 'K06.01', descricao: 'Retração gengival generalizada' },
  { codigo: 'K06.09', descricao: 'Retração gengival, não especificada' },
  { codigo: 'K06.1', descricao: 'Hiperplasia gengival [tuberosidade]' },
  { codigo: 'K06.10', descricao: 'Fibromatose gengival' },
  { codigo: 'K06.18', descricao: 'Outras hiperplasias gengivais especificadas' },
  { codigo: 'K06.2', descricao: 'Lesões da gengiva e do rebordo alveolar associadas a traumatismos' },
  { codigo: 'K06.20', descricao: 'Lesão gengival devido a oclusão traumática' },
  { codigo: 'K06.21', descricao: 'Lesão gengival devido a escovação' },
  { codigo: 'K06.22', descricao: 'Queratose por atrito [funcional]' },
  { codigo: 'K06.23', descricao: 'Hiperplasia irritativa do rebordo alveolar [devido à dentadura]' },
  { codigo: 'K06.28', descricao: 'Outras lesões especificadas da gengiva e do rebordo alveolar por trauma' },
  { codigo: 'K06.29', descricao: 'Lesões da gengiva e do rebordo alveolar não especificadas, por trauma' },
  { codigo: 'K06.8', descricao: 'Outros transtornos especificados da gengiva e do rebordo alveolar' },
  { codigo: 'K06.80', descricao: 'Cisto gengival do adulto' },
  { codigo: 'K06.81', descricao: 'Granuloma periférico de células gigantes [epúlide de células gigantes]' },
  { codigo: 'K06.82', descricao: 'Epúlide fibroso' },
  { codigo: 'K06.83', descricao: 'Granuloma piogênico (gengiva)' },
  { codigo: 'K06.84', descricao: 'Rebordo gengival flutuante' },
  { codigo: 'K06.88', descricao: 'Outros transtornos especificados da gengiva' },
  { codigo: 'K06.9', descricao: 'Transtornos da gengiva e do rebordo alveolar, sem outra especificação' },

  { codigo: 'K07', descricao: 'Anomalias dentofaciais (inclusive a maloclusão)' },
  { codigo: 'K07.0', descricao: 'Anomalias importantes (major) do tamanho da mandíbula' },
  { codigo: 'K07.00', descricao: 'Macrognatismo maxilar [hiperplasia maxilar]' },
  { codigo: 'K07.01', descricao: 'Macrognatismo mandibular [hiperplasia mandibular]' },
  { codigo: 'K07.02', descricao: 'Macrognatismo, ambos os maxilares' },
  { codigo: 'K07.03', descricao: 'Micrognatismo maxilar [hipoplasia maxilar]' },
  { codigo: 'K07.04', descricao: 'Micrognatismo mandibular [hipoplasia mandibular]' },
  { codigo: 'K07.05', descricao: 'Micrognatismo, ambos os maxilares' },
  { codigo: 'K07.08', descricao: 'Outras anomalias do tamanho da mandíbula especificadas' },
  { codigo: 'K07.09', descricao: 'Anomalia do tamanho da mandíbula, não especificada' },
  { codigo: 'K07.1', descricao: 'Anomalias da relação entre a mandíbula e a base do crânio' },
  { codigo: 'K07.10', descricao: 'Assimetrias' },
  { codigo: 'K07.11', descricao: 'Prognatismo mandibular' },
  { codigo: 'K07.12', descricao: 'Prognatismo maxilar' },
  { codigo: 'K07.13', descricao: 'Retrognatismo mandibular' },
  { codigo: 'K07.14', descricao: 'Retrognatismo maxilar' },
  { codigo: 'K07.18', descricao: 'Outras anomalias especificadas da relação mandíbula/base do crânio' },
  { codigo: 'K07.19', descricao: 'Anomalia não especificada da relação mandíbula/base do crânio' },
  { codigo: 'K07.2', descricao: 'Anomalias da relação entre as arcadas dentárias' },
  { codigo: 'K07.20', descricao: 'Disto-oclusão' },
  { codigo: 'K07.21', descricao: 'Mésio-oclusão' },
  { codigo: 'K07.22', descricao: 'Superposição excessiva [mordida horizontal]' },
  { codigo: 'K07.23', descricao: 'Sobremordida excessiva [vertical]' },
  { codigo: 'K07.24', descricao: 'Mordida aberta' },
  { codigo: 'K07.25', descricao: 'Mordida cruzada (anterior, posterior)' },
  { codigo: 'K07.26', descricao: 'Desvio da linha mediana' },
  { codigo: 'K07.27', descricao: 'Oclusão lingual posterior dos dentes inferiores' },
  { codigo: 'K07.28', descricao: 'Outras anomalias especificadas da relação entre as arcadas dentárias' },
  { codigo: 'K07.29', descricao: 'Anomalia da relação entre as arcadas dentárias, não especificada' },
  { codigo: 'K07.3', descricao: 'Anomalias da posição dos dentes' },
  { codigo: 'K07.30', descricao: 'Apinhamento [imbricação]' },
  { codigo: 'K07.31', descricao: 'Deslocamento' },
  { codigo: 'K07.32', descricao: 'Rotação' },
  { codigo: 'K07.33', descricao: 'Espaçamento anormal [diastema]' },
  { codigo: 'K07.34', descricao: 'Transposição' },
  { codigo: 'K07.35', descricao: 'Dentes inclusos ou impactados com posição anormal' },
  { codigo: 'K07.38', descricao: 'Outras anomalias especificadas da posição dos dentes' },
  { codigo: 'K07.39', descricao: 'Anomalia da posição dos dentes, não especificada' },
  { codigo: 'K07.4', descricao: 'Má oclusão, não especificada' },
  { codigo: 'K07.5', descricao: 'Anormalidades dentofaciais funcionais' },
  { codigo: 'K07.50', descricao: 'Fechamento anormal dos maxilares' },
  { codigo: 'K07.51', descricao: 'Má oclusão devido à deglutição anormal' },
  { codigo: 'K07.54', descricao: 'Má oclusão devido à respiração pela boca' },
  { codigo: 'K07.55', descricao: 'Má oclusão devido a hábitos linguais, labiais ou chupar os dedos' },
  { codigo: 'K07.58', descricao: 'Outras anormalidades dentofaciais funcionais especificadas' },
  { codigo: 'K07.59', descricao: 'Anormalidade dentofacial funcional, não especificada' },
  { codigo: 'K07.6', descricao: 'Distúrbios da articulação temporomandibular' },
  { codigo: 'K07.60', descricao: 'Síndrome da dor e disfunção da ATM [Costen]' },
  { codigo: 'K07.61', descricao: 'Click (estalido) da articulação temporomandibular' },
  { codigo: 'K07.62', descricao: 'Deslocamento e subluxação recorrentes da ATM' },
  { codigo: 'K07.63', descricao: 'Dor na articulação temporomandibular, não classificada em outra parte' },
  { codigo: 'K07.64', descricao: 'Rigidez da articulação temporomandibular, não classificada em outra parte' },
  { codigo: 'K07.65', descricao: 'Osteófito da articulação temporomandibular' },
  { codigo: 'K07.68', descricao: 'Outras doenças especificadas da ATM' },
  { codigo: 'K07.69', descricao: 'Distúrbio da articulação temporomandibular, não especificado' },

  { codigo: 'K08', descricao: 'Outros transtornos dos dentes e de suas estruturas de sustentação' },
  { codigo: 'K08.0', descricao: 'Exfoliação dos dentes devido a causas sistêmicas' },
  { codigo: 'K08.0X', descricao: 'Exfoliação dos dentes devido a doenças dos tecidos circundantes/causas sistêmicas' },
  { codigo: 'K08.1', descricao: 'Perda de dentes devido a acidente, extração ou doença periodontal localizada' },
  { codigo: 'K08.2', descricao: 'Atrofia do rebordo alveolar sem dentes' },
  { codigo: 'K08.3', descricao: 'Raiz dentária retida' },
  { codigo: 'K08.8', descricao: 'Outros transtornos especificados dos dentes e estruturas de sustentação' },
  { codigo: 'K08.80', descricao: 'Dor de dente SOE' },
  { codigo: 'K08.81', descricao: 'Irregularidade do processo alveolar' },
  { codigo: 'K08.82', descricao: 'Hipertrofia do rebordo alveolar SOE' },
  { codigo: 'K08.88', descricao: 'Outros transtornos dos dentes e estruturas de sustentação' },
  { codigo: 'K08.9', descricao: 'Transtorno dos dentes e de suas estruturas de sustentação, sem outra especificação' },

  { codigo: 'K09', descricao: 'Cistos da região bucal, não classificados em outra parte' },
  { codigo: 'K09.0', descricao: 'Cistos odontogênicos de desenvolvimento' },
  { codigo: 'K09.00', descricao: 'Cisto de erupção' },
  { codigo: 'K09.01', descricao: 'Cisto gengival' },
  { codigo: 'K09.02', descricao: 'Queratocisto [primordial]' },
  { codigo: 'K09.03', descricao: 'Cisto folicular [dentígero]' },
  { codigo: 'K09.04', descricao: 'Cisto periodontal lateral' },
  { codigo: 'K09.08', descricao: 'Outros cistos odontogênicos de desenvolvimento especificados' },
  { codigo: 'K09.09', descricao: 'Cisto odontogênico de desenvolvimento, não especificado' },
  { codigo: 'K09.1', descricao: 'Cistos de desenvolvimento (não-odontogênicos) da região bucal' },
  { codigo: 'K09.10', descricao: 'Cisto globulomaxilar' },
  { codigo: 'K09.11', descricao: 'Cisto mesopalatino' },
  { codigo: 'K09.12', descricao: 'Cisto nasopalatino [canal dos incisivos]' },
  { codigo: 'K09.13', descricao: 'Cisto da papila palatina' },
  { codigo: 'K09.18', descricao: 'Outros cistos de desenvolvimento da região bucal especificados' },
  { codigo: 'K09.19', descricao: 'Cisto de desenvolvimento da região bucal, não especificado' },
  { codigo: 'K09.2', descricao: 'Outros cistos das mandíbulas' },
  { codigo: 'K09.20', descricao: 'Cisto ósseo aneurismático' },
  { codigo: 'K09.21', descricao: 'Cisto ósseo solitário [traumático] [hemorrágico]' },
  { codigo: 'K09.22', descricao: 'Cistos epiteliais dos maxilares não identificáveis como odontogênicos ou não' },
  { codigo: 'K09.28', descricao: 'Outros cistos dos maxilares especificados' },
  { codigo: 'K09.29', descricao: 'Cisto da mandíbula, não especificado' },
  { codigo: 'K09.8', descricao: 'Outros cistos da região oral, não classificados em outra parte' },
  { codigo: 'K09.80', descricao: 'Cisto dermóide' },
  { codigo: 'K09.81', descricao: 'Cisto epidermóide' },
  { codigo: 'K09.82', descricao: 'Cisto gengival do recém-nascido' },
  { codigo: 'K09.83', descricao: 'Cisto palatino do recém-nascido [pérolas de Epstein]' },
  { codigo: 'K09.84', descricao: 'Cisto nasoalveolar [nasolabial]' },
  { codigo: 'K09.85', descricao: 'Cisto linfoepitelial da boca' },
  { codigo: 'K09.88', descricao: 'Outros cistos da região oral especificados' },
  { codigo: 'K09.9', descricao: 'Cistos da região oral, sem outras especificações' },

  { codigo: 'K10', descricao: 'Outras doenças dos maxilares' },
  { codigo: 'K10.0', descricao: 'Distúrbios do desenvolvimento dos maxilares' },
  { codigo: 'K10.00', descricao: 'Torus mandibular' },
  { codigo: 'K10.01', descricao: 'Torus palatino' },
  { codigo: 'K10.02', descricao: 'Cisto ósseo latente [cisto de Stafne]' },
  { codigo: 'K10.08', descricao: 'Outros distúrbios de desenvolvimento dos maxilares' },
  { codigo: 'K10.09', descricao: 'Distúrbios de desenvolvimento dos maxilares, não especificados' },
  { codigo: 'K10.1', descricao: 'Granuloma central de células gigantes' },
  { codigo: 'K10.2', descricao: 'Afecções inflamatórias dos maxilares' },
  { codigo: 'K10.20', descricao: 'Osteíte dos maxilares' },
  { codigo: 'K10.21', descricao: 'Osteomielite dos maxilares' },
  { codigo: 'K10.22', descricao: 'Periostite dos maxilares' },
  { codigo: 'K10.23', descricao: 'Periostite maxilar crônica' },
  { codigo: 'K10.24', descricao: 'Osteomielite neonatal maxilar' },
  { codigo: 'K10.25', descricao: 'Sequestro ósseo maxilar' },
  { codigo: 'K10.26', descricao: 'Osteorradionecrose' },
  { codigo: 'K10.28', descricao: 'Outras afecções inflamatórias dos maxilares especificadas' },
  { codigo: 'K10.29', descricao: 'Afecção inflamatória dos maxilares, não especificada' },
  { codigo: 'K10.3', descricao: 'Alveolite dos maxilares [osteíte alveolar / alveolite seca]' },
  { codigo: 'K10.8', descricao: 'Outras doenças especificadas dos maxilares' },
  { codigo: 'K10.80', descricao: 'Querubismo' },
  { codigo: 'K10.81', descricao: 'Hiperplasia condilar unilateral' },
  { codigo: 'K10.82', descricao: 'Hipoplasia condilar unilateral' },
  { codigo: 'K10.83', descricao: 'Displasia fibrosa dos maxilares' },
  { codigo: 'K10.88', descricao: 'Outras doenças dos maxilares especificadas [exostose maxilar]' },
  { codigo: 'K10.9', descricao: 'Doença dos maxilares, não especificada' },

  { codigo: 'K11', descricao: 'Doenças das glândulas salivares' },
  { codigo: 'K11.0', descricao: 'Atrofia de glândula salivar' },
  { codigo: 'K11.1', descricao: 'Hipertrofia de glândula salivar' },
  { codigo: 'K11.2', descricao: 'Sialadenite' },
  { codigo: 'K11.3', descricao: 'Abscesso de glândula salivar' },
  { codigo: 'K11.4', descricao: 'Fístula de glândula salivar' },
  { codigo: 'K11.5', descricao: 'Sialolitíase [cálculo de canal salivar]' },
  { codigo: 'K11.6', descricao: 'Mucocele de glândula salivar [rânula]' },
  { codigo: 'K11.60', descricao: 'Cisto mucoso de retenção' },
  { codigo: 'K11.61', descricao: 'Cisto mucoso de extravasamento' },
  { codigo: 'K11.69', descricao: 'Mucocele de glândula salivar, não especificada' },
  { codigo: 'K11.7', descricao: 'Alterações da secreção salivar' },
  { codigo: 'K11.70', descricao: 'Hipossecreção salivar' },
  { codigo: 'K11.71', descricao: 'Xerostomia' },
  { codigo: 'K11.72', descricao: 'Hipersecreção salivar' },
  { codigo: 'K11.78', descricao: 'Outros distúrbios da secreção salivar especificados' },
  { codigo: 'K11.79', descricao: 'Distúrbios da secreção salivar, não especificados' },
  { codigo: 'K11.8', descricao: 'Outras doenças das glândulas salivares' },
  { codigo: 'K11.80', descricao: 'Lesão linfoepitelial benigna de glândula salivar' },
  { codigo: 'K11.81', descricao: 'Doença de Mikulicz' },
  { codigo: 'K11.82', descricao: 'Estenose de canal salivar' },
  { codigo: 'K11.83', descricao: 'Sialectasia' },
  { codigo: 'K11.84', descricao: 'Sialose' },
  { codigo: 'K11.85', descricao: 'Sialometaplasia necrotizante' },
  { codigo: 'K11.88', descricao: 'Outras doenças das glândulas salivares especificadas' },
  { codigo: 'K11.9', descricao: 'Doença da glândula salivar, sem outra especificação [sialoadenopatia SOE]' },

  { codigo: 'K12', descricao: 'Estomatite e lesões correlatas' },
  { codigo: 'K12.0', descricao: 'Aftas bucais recidivantes' },
  { codigo: 'K12.00', descricao: 'Aftas recidivantes (minor) [estomatite aftosa]' },
  { codigo: 'K12.01', descricao: 'Periadenite mucosa necrótica recidivante [aftas major / aftose de Sutton]' },
  { codigo: 'K12.02', descricao: 'Estomatite herpetiforme [erupção herpetiforme]' },
  { codigo: 'K12.03', descricao: 'Aftose de Bednar' },
  { codigo: 'K12.08', descricao: 'Outras aftas bucais recidivantes especificadas' },
  { codigo: 'K12.09', descricao: 'Aftas orais recidivantes, não especificadas' },
  { codigo: 'K12.1', descricao: 'Outras formas de estomatite' },
  { codigo: 'K12.10', descricao: 'Estomatite por artefato' },
  { codigo: 'K12.11', descricao: 'Estomatite geográfica' },
  { codigo: 'K12.12', descricao: 'Estomatite devido à prótese' },
  { codigo: 'K12.13', descricao: 'Hiperplasia papilar do palato' },
  { codigo: 'K12.14', descricao: 'Estomatite de contato [estomatite por rolo de algodão]' },
  { codigo: 'K12.18', descricao: 'Outras formas de estomatite especificadas' },
  { codigo: 'K12.19', descricao: 'Estomatite, não especificada' },
  { codigo: 'K12.2', descricao: 'Celulite e abscesso da boca [flegmão / abscesso submandibular]' },

  { codigo: 'K13', descricao: 'Outras doenças do lábio e da mucosa oral' },
  { codigo: 'K13.0', descricao: 'Doenças dos lábios' },
  { codigo: 'K13.00', descricao: 'Queilite angular [queilose angular]' },
  { codigo: 'K13.01', descricao: 'Queilite glandular apostematosa' },
  { codigo: 'K13.02', descricao: 'Queilite exfoliativa' },
  { codigo: 'K13.03', descricao: 'Queilite SOE' },
  { codigo: 'K13.04', descricao: 'Queilodinia' },
  { codigo: 'K13.08', descricao: 'Outras doenças do lábio especificadas' },
  { codigo: 'K13.09', descricao: 'Doença do lábio, não especificada' },
  { codigo: 'K13.1', descricao: 'Mordedura da mucosa das bochechas e dos lábios' },
  { codigo: 'K13.2', descricao: 'Leucoplasia e outras afecções do epitélio oral, inclusive da língua' },
  { codigo: 'K13.20', descricao: 'Leucoplasia idiopática' },
  { codigo: 'K13.21', descricao: 'Leucoplasia associada ao tabaco' },
  { codigo: 'K13.22', descricao: 'Eritroplasia' },
  { codigo: 'K13.23', descricao: 'Leucoedema' },
  { codigo: 'K13.24', descricao: 'Palato do fumante [leucoqueratose por nicotina / estomatite nicotínica]' },
  { codigo: 'K13.28', descricao: 'Outras leucoplasias especificadas' },
  { codigo: 'K13.29', descricao: 'Leucoplasia, não especificada [leucoplasia SOE]' },
  { codigo: 'K13.3', descricao: 'Leucoplasia pilosa' },
  { codigo: 'K13.4', descricao: 'Lesões granulomatosas e granulomatóides da mucosa oral' },
  { codigo: 'K13.40', descricao: 'Granuloma piogênico (mucosa oral)' },
  { codigo: 'K13.41', descricao: 'Granuloma eosinófilo da mucosa oral' },
  { codigo: 'K13.42', descricao: 'Xantoma verrucoso [histiocitose Y]' },
  { codigo: 'K13.48', descricao: 'Outras lesões granulomatóides da mucosa oral, não especificadas' },
  { codigo: 'K13.49', descricao: 'Lesão granulomatosa e granulomatóide da mucosa oral, não especificada' },
  { codigo: 'K13.5', descricao: 'Fibrose oral submucosa' },
  { codigo: 'K13.6', descricao: 'Hiperplasia irritativa da mucosa oral' },
  { codigo: 'K13.7', descricao: 'Outras lesões e as não especificadas da mucosa oral' },
  { codigo: 'K13.70', descricao: 'Pigmentação excessiva por melanina [melanoplasia / melanose do fumante]' },
  { codigo: 'K13.71', descricao: 'Fístula oral' },
  { codigo: 'K13.72', descricao: 'Tatuagem deliberada' },
  { codigo: 'K13.73', descricao: 'Mucinose oral focal' },
  { codigo: 'K13.78', descricao: 'Outras lesões da mucosa oral especificadas [linha alba]' },
  { codigo: 'K13.79', descricao: 'Lesão da mucosa oral, não especificada' },

  { codigo: 'K14', descricao: 'Doenças da língua' },
  { codigo: 'K14.0', descricao: 'Glossite' },
  { codigo: 'K14.00', descricao: 'Abscesso da língua' },
  { codigo: 'K14.01', descricao: 'Ulceração traumática da língua' },
  { codigo: 'K14.08', descricao: 'Outras glossites especificadas' },
  { codigo: 'K14.09', descricao: 'Glossite, não especificada [úlcera da língua SOE]' },
  { codigo: 'K14.1', descricao: 'Língua geográfica [glossite areata exfoliativa / migratória benigna]' },
  { codigo: 'K14.2', descricao: 'Glossite rombóide mediana' },
  { codigo: 'K14.3', descricao: 'Hipertrofia das papilas linguais' },
  { codigo: 'K14.30', descricao: 'Língua saburrosa' },
  { codigo: 'K14.31', descricao: 'Língua pilosa [língua pilosa/vilosa negra]' },
  { codigo: 'K14.32', descricao: 'Hipertrofia das papilas foliáceas' },
  { codigo: 'K14.38', descricao: 'Outras hipertrofias das papilas linguais especificadas' },
  { codigo: 'K14.39', descricao: 'Hipertrofia das papilas linguais, não especificada' },
  { codigo: 'K14.5', descricao: 'Língua escrotal [fissurada / gretada / sulcada]' },
  { codigo: 'K14.6', descricao: 'Glossodínia' },
  { codigo: 'K14.60', descricao: 'Glossopirose [língua queimante]' },
  { codigo: 'K14.61', descricao: 'Glossodínia [língua dolorosa]' },
  { codigo: 'K14.68', descricao: 'Outras glossodínias especificadas' },
  { codigo: 'K14.69', descricao: 'Glossodínia, não especificada' },
  { codigo: 'K14.8', descricao: 'Outras doenças da língua' },
  { codigo: 'K14.80', descricao: 'Língua crenada [indentada]' },
  { codigo: 'K14.81', descricao: 'Hipertrofia da língua [hemi-hipertrofia]' },
  { codigo: 'K14.82', descricao: 'Atrofia da língua [hemiatrofia]' },
  { codigo: 'K14.88', descricao: 'Outras doenças especificadas da língua [doenças da amígdala lingual]' },
  { codigo: 'K14.9', descricao: 'Doença da língua, sem outra especificação [glossopatia SOE]' },
];

export default CID_ODONTOLOGICO;
